import { NodeResult } from "../models/net/result/node-result";

export class UtilityFunctions {

    private constructor() { }

    public static splitByCapitalLetters(rawText: string): string {

        const words = rawText.split(/(?=[A-Z])/);
        const result = words.join(' ');

        return result;
    }

    public static getUserSession = (): string => {

        let result: string = "";

        const cookieName = "userSession=";
        const cookieString = document.cookie.split("; ").find(cookie => cookie.startsWith(cookieName));

        if (cookieString) {

            const sessionData = decodeURIComponent(cookieString.split("=")[1]);

            try {

                result = sessionData; // JSON.parse(sessionData) as UserSession;

            } catch (error) {

                console.error("Failed to parse user session from cookie:", error);
            }
        }

        return result;
    }

    public static getSubdomain = (): string => {

        let result: string = "";

        const hostname: string = window.location.hostname;
        const parts = hostname.split('.');

        if (parts.length > 1) {

            result = parts[0];
        }

        return result;
    }

    public static extractChildNodes = (nodes: NodeResult[], targetId: number): NodeResult[] => {

        for (const node of nodes) {

            if (node.NodeId === targetId) {

                return node.Nodes; // Return only the child nodes of the targetId
            }

            if (node.Nodes.length > 0) {

                const result = this.extractChildNodes(node.Nodes, targetId);

                if (result.length > 0) return result;
            }
        }

        return [];
    }
}
